<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title>
        {{
          selectedVehicleGroup
            ? $vuetify.lang.t('$vuetify.VEHICLE_GROUPS.EDIT')
            : $vuetify.lang.t('$vuetify.VEHICLE_GROUPS.ADD_NEW')
        }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="groupName"
          :label="$vuetify.lang.t('$vuetify.VEHICLE_GROUPS.GROUP_NAME')"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="show = false">
          {{ $vuetify.lang.t('$vuetify.CLOSE') }}
        </v-btn>
        <v-btn color="primary" class="secondary--text" @click="onVehicleGroupSave()">
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'VehicleGroupEditDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      saveButtonDisabled: true,
      groupName: ''
    }
  },
  computed: {
    ...mapGetters('vehicleGroups', ['selectedVehicleGroup']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
          this.setSelectedVehicleGroup(undefined)
        }
      }
    }
  },
  watch: {
    selectedVehicleGroup() {
      if (this.selectedVehicleGroup) {
        this.groupName = this.selectedVehicleGroup.name
      } else {
        this.groupName = ''
      }
    }
  },
  methods: {
    ...mapMutations('vehicleGroups', [
      'setSelectedVehicleGroup',
      'setVehicleGroupValue'
    ]),
    ...mapActions('vehicleGroups', ['putVehicleGroup', 'postVehicleGroup']),
    async onVehicleGroupSave() {
      if (this.selectedVehicleGroup) {
        await this.putVehicleGroup({
          this: this,
          ID: this.selectedVehicleGroup.ID,
          name: this.groupName
        })
        this.show = false
      } else {
        await this.postVehicleGroup({ this: this, name: this.groupName })
        this.show = false
      }
      this.show = false
    }
  }
}
</script>
